import ReactLibrary, { useEffect, useRef, Children } from 'react'
import Slider from 'react-slick'

import { makeCustomRounding } from 'utils/custom-rounding'

import { NextArrow } from './next-arrow'
import { PrevArrow } from './prev-arrow'
import { Wrapper } from './style'

type Props = {
  itemsPerSlides?: number
  gapPerItems?: number
  itemWidth?: number
  slidesToScroll: number
}

const round = makeCustomRounding(0.7)

export const ResponsiveCarousel: React.FC<Props> = ({
  itemsPerSlides,
  children,
  gapPerItems = 0,
  itemWidth = 0,
  slidesToScroll,
}) => {
  const wrapperRef = useRef<HTMLDivElement>(null)

  const [wrapperWidth, setWrapperWidth] = ReactLibrary.useState<number>()
  const [autoItemsPerSlides, setAutoItemsPerSlides] = ReactLibrary.useState<number>(1)
  const childrenLength = Children.count(children)
  const onResizeHandler = () => {
    setWrapperWidth(wrapperRef?.current?.clientWidth)
  }
  useEffect(() => {
    if (wrapperRef) {
      setWrapperWidth(wrapperRef?.current?.clientWidth)
      window.addEventListener('resize', onResizeHandler)
    }
    return () => window.removeEventListener('resize', onResizeHandler)
  }, [wrapperRef])

  useEffect(() => {
    if (!itemsPerSlides) {
      if (!wrapperWidth || wrapperWidth <= 0 || childrenLength === 0) {
        setAutoItemsPerSlides(1)
      } else {
        const calculatedItemsPerSlides = round(wrapperWidth / (gapPerItems + itemWidth))
        setAutoItemsPerSlides(Math.min(calculatedItemsPerSlides, childrenLength))
      }
    }
  }, [wrapperWidth, itemsPerSlides, gapPerItems, itemWidth, childrenLength])

  return (
    <Wrapper ref={wrapperRef}>
      <Slider
        nextArrow={<NextArrow />}
        prevArrow={<PrevArrow />}
        slidesToShow={itemsPerSlides || autoItemsPerSlides}
        slidesToScroll={slidesToScroll}
        infinite={false}
      >
        {children}
      </Slider>
    </Wrapper>
  )
}
